import { pageView, ensightenView } from 'utils/tracking';
import {
  FETCH_SITE_REQUEST,
  FETCH_SITE_SUCCESS,
  FETCH_SITE_FAILURE
} from 'actions/SiteActions';

const initialState = {
  isFetching: false,
  site: null,
  config: {},
  currentPath: null
};

export default function site(state = initialState, action) {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE': {
      pageView(action.payload.location.pathname);
      if (state.currentPath && action.payload.location.pathname !== '/thanks') {
        ensightenView(action.payload.location.pathname, state.currentPath, action.payload.cart, action.payload.products, null);
      }
      return Object.assign({}, state, {
        currentPath: action.payload.location.pathname
      });
    }
    case FETCH_SITE_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
//      site: null - Commented out to test improving the speed of switching languages
      });
    }
    case FETCH_SITE_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        site: action.site,
        config: action.config
      });
    }
    case FETCH_SITE_FAILURE: {
      return initialState;
    }
    default:
      return state;
  }
}
